module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/3-54aab4b09f413d2a8b1e10ef46159529.webp";